var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpwardIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.44078 11.1934L10.5533 11.1934C10.8082 11.1916 11.0581 11.1229 11.2782 10.9943C11.4982 10.8657 11.6807 10.6816 11.8074 10.4604C11.934 10.2392 12.0005 9.98868 12 9.73379C11.9995 9.47891 11.9322 9.2286 11.8048 9.00786L7.74678 2.23336C7.61696 2.01903 7.43411 1.84176 7.21586 1.71864C6.99761 1.59553 6.75131 1.53072 6.50073 1.53047C6.25015 1.53022 6.00373 1.59453 5.78523 1.71721C5.56673 1.83988 5.38353 2.01679 5.25328 2.23086L1.19828 9.00036C1.06931 9.22067 1.00049 9.47099 0.998711 9.72626C0.996929 9.98153 1.06225 10.2328 1.18813 10.4549C1.31401 10.677 1.49603 10.8621 1.71596 10.9917C1.93589 11.1213 2.18551 11.1908 2.44078 11.1934Z",
    fill: "#00AA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwardIconGreen);
export default __webpack_public_path__ + "static/media/ArrowUpwardIcon_green.424be1d67b23ec8936def99d44b43232.svg";
export { ForwardRef as ReactComponent };